import Control from '@/Controls/Control';
import KendoDateAndOrTimePickerViewModelBase from '@/Components/KendoDateTimePicker/ViewModels/KendoDateAndOrTimePickerViewModelBase';
import Utilities from '@/Utility/Utilities';

export default class KendoDateAndOrTimePicker extends Control {

    protected jQueryControl: JQuery;
    private isChanging: boolean;

    public constructor(protected viewModel: KendoDateAndOrTimePickerViewModelBase, protected element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    protected onWidgetCreatedCallback(widget: kendo.ui.IDatePickerExt): void {
        const $input = this.jQueryControl.find('input');
        this.addEventHandler('keyup', $input, Utilities.debounce((event: JQuery.KeyUpEvent) => this.changeCallback(widget, event), 1000));
        this.addEventHandler('change', $input, (event: JQuery.ChangeEvent) => this.changeCallback(widget, event));
        this.viewModel.onResetted(() => widget._change(''));
    }

    private changeCallback(widget: kendo.ui.IDatePickerExt, ev: JQuery.TriggeredEvent): void {
        if (this.isDisposed)
            return;
        // Endlosschleife aufgrund von widget._change(val) verhindern
        if (this.isChanging)
            return;
        this.isChanging = true;
        const val = $(ev.currentTarget).val() as string;
        if (val !== widget._oldText) {
            widget._change(val);
        }

        // Der eigentliche Wert wird asynchron in das ViewModel übertragen; wir wollen erst danach den rawValue aktualisieren
        this.async(() => {
            const oldValue = this.viewModel.rawValue();
            this.viewModel.rawValue(val);
            // CF-12034: Wenn sich der Wert z.B. durch gedrückt halten der Backspace-Taste
            // nicht geändert hat, müssen die Subscriber manuell benachrichtigt werden.
            if (oldValue == val)
                this.viewModel.rawValue.notifySubscribers(val);
        }, 1);

        this.isChanging = false;
    }

    protected createControl(element: JQuery, defaultTemplate: string): JQuery {
        if (!element) {
            element = $('<div></div>');
        }

        if (element.find('input').length === 0) {
            element.append(defaultTemplate);
        }

        return element;
    }

    public addLabelReference(label: JQuery): JQuery {
        let id = this.identifier + '-input';
        this.getControl().find('input').attr('id', id);
        label.attr('for', id);
        return label;
    }
}